import * as Yup from "yup";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_FILE_COUNT = 5;

const AddServicevalidationSchema = Yup.object({
  owner_name: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must be less than 50 characters")
    .matches(/^[A-Za-z ]+$/, "Name must only contain letters and spaces"),

  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format")
    .max(100, "Email must not exceed 100 characters")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email format"
    ),

  mobile_number: Yup.string()
    .required("Mobile number is required")
    .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number starting with 6-9"),

  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password must not exceed 20 characters")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter")
    .matches(/[a-z]/, "Must contain at least one lowercase letter")
    .matches(/[0-9]/, "Must contain at least one number")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Must contain at least one special character"),

  services_type: Yup.array()
    .required("Service type is required")
    .min(1, "Select at least one service type"),

  subservices: Yup.array()
    .required("Specialization is required")
    .min(1, "Select at least one specialization"),

  worklocation: Yup.string()
    .required("Work location is required")
    .min(5, "Work location must be at least 5 characters")
    .max(150, "Work location must not exceed 150 characters"),

  homeaddress: Yup.string()
    .required("Home address is required")
    .min(5, "Home address must be at least 5 characters")
    .max(150, "Home address must not exceed 150 characters"),

  keywords: Yup.array()
    .required("Keywords are required")
    .min(1, "Enter at least one keyword")
    .max(10, "You can add up to 10 keywords")
    .of(
      Yup.string()
        .required("Keyword is required")
        .min(2, "Keyword must be at least 2 characters")
        .max(30, "Keyword must not exceed 30 characters")
    ),

  account_no: Yup.string()
    .required("Account number is required")
    .matches(/^\d{9,18}$/, "Account number must be between 9 to 18 digits"),
payment_plan_id: Yup.string().required("Payment plan is required"),

  ifsc_code: Yup.string()
    .required("IFSC code is required")
    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format")
    .length(11, "IFSC code must be exactly 11 characters"),

  passbook_name: Yup.string()
    .required("Passbook name is required")
    .min(3, "Passbook name must be at least 3 characters")
    .max(50, "Passbook name must not exceed 50 characters")
    .matches(/^[A-Za-z ]+$/, "Passbook name must only contain letters and spaces"),

  experiance: Yup.number()
    .typeError("Experience must be a number")
    .min(0, "Experience cannot be negative")
    .max(100, "Experience cannot exceed 100 years")
    .required("Experience is required"),

  pan_card_number: Yup.string()
    .required("PAN card number is required")
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN format. Example: ABCDE1234F")
    .length(10, "PAN number must be exactly 10 characters"),

  additional_details: Yup.string()
    .required("Additional details are required")
    .test(
      "min-words",
      "Additional details must be at least 5 words",
      value => value && value.trim().split(/\s+/).length >= 5
    )
    .max(500, "Details must be less than 500 characters"),

  profile_photo: Yup.mixed()
    .required("Profile photo is required")
    .test("fileSize", "Profile photo must be less than 2MB", value =>
      value && value instanceof File && value.size <= MAX_FILE_SIZE
    ),

  work_place_gps: Yup.mixed()
    .nullable()
    .test("fileSize", "Work GPS photo must be less than 2MB", value =>
      !value || (value instanceof File && value.size <= MAX_FILE_SIZE)
    ),

  idproof_photo: Yup.array()
    .required("ID proof photos are required")
    .min(1, "At least 1 ID proof photo is required")
    .max(MAX_FILE_COUNT, `You can upload up to ${MAX_FILE_COUNT} ID proof photos`)
    .test("fileSize", "Each ID proof photo must be less than 2MB", files =>
      files.every(file => file instanceof File && file.size <= MAX_FILE_SIZE)
    ),

  experience_certificates: Yup.array()
    .required("Experience certificates are required")
    .min(1, "At least 1 experience certificate is required")
    .max(MAX_FILE_COUNT, `You can upload up to ${MAX_FILE_COUNT} experience certificates`)
    .test("fileSize", "Each experience certificate must be less than 2MB", files =>
      files.every(file => file instanceof File && file.size <= MAX_FILE_SIZE)
    ),
});

export default AddServicevalidationSchema;
